module.exports = ".mailchimp-iframe {\n  border: none;\n  width: 100%;\n  height: 600px;\n}\n"